function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { ActionButton } from '../Button/Action';
import { ActionIconName } from '../Icons';
import { StandardModal } from './StandardModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionModal = props => {
  const Footer = /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: "9px 20px 20px 20px",
        bottom: 20,
        right: 20
      }
    },
    children: props.footer
  });
  const CloseIcon = /*#__PURE__*/_jsx(ActionButton, {
    iconProps: {
      iconName: ActionIconName.Close
    },
    styles: {
      root: {
        padding: 16
      }
    },
    onClick: () => props.onDismiss()
  });
  return /*#__PURE__*/_jsx(StandardModal, _objectSpread(_objectSpread({}, props), {}, {
    closeIcon: CloseIcon,
    footer: Footer,
    children: props.children
  }));
};